// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"179a97b8","239":"5d2c3e41","455":"951119c6","977":"0e16b692"}[chunkId] + ".chunk.js";
};